module.exports = __webpack_public_path__ + "img/ane.deec14fe.png";